import React, { useEffect, useState } from "react";
import { uploadImage } from "../../utils/upload";

const ImageUploader = ({ ids = [], setIds, uploadOne, preventEvent }) => {
  const [selectedImages, setSelectedImages] = useState([]);
  const [uploading, setUploading] = useState(false);
  useEffect(() => {
    typeof preventEvent !== "undefined" && preventEvent(uploading);
  }, [uploading]);
  const handleFileChange = async (event) => {
    const files = event.target.files;

    if (files.length > 0) {
      const newImages = Array.from(files).map((file) => {
        return {
          file,
          imageUrl: URL.createObjectURL(file),
          uploadStatus: "pending", // 初始状态为待上传
        };
      });

      setSelectedImages((prevImages) => [...prevImages, ...newImages]);

      // 上传图片
      for (const newImage of newImages) {
        await uploadImageAsync(newImage);
      }
    }
  };
  useEffect(() => {
    if (!ids.length) {
      setSelectedImages([]);
    }
  }, [ids]);
  const uploadImageAsync = async (image) => {
    try {
      setUploading(true);

      const uploadTimeout = 30000; // 设置超时时间为30秒
      const uploadPromise = uploadImage(image.file);
      const uploadResult = await Promise.race([
        uploadPromise,
        new Promise((_, reject) =>
          setTimeout(() => reject(new Error("Upload timeout")), uploadTimeout)
        ),
      ]);

      if (typeof uploadResult === "number") {
        // 上传成功
        image.uploadStatus = "success";
        // 将上传成功的整数传递给父组件
        setIds((prevIds) => {
          return [...prevIds, uploadResult];
        });
      } else {
        // 上传失败
        image.uploadStatus = "fail";
      }
      console.log(`Image ${image.file.name} upload result:`, uploadResult);
    } catch (error) {
      console.error(`Failed to upload image ${image.file.name}`, error);
      image.uploadStatus = "fail";
    } finally {
      setUploading(false);
      // 更新状态，重新渲染组件
      setSelectedImages((prevImages) => [...prevImages]);
    }
  };

  return (
    <div>
      <div style={{ display: "flex", flexWrap: "wrap" }}>
        {selectedImages.map((image, index) => (
          <div key={index} style={{ margin: "5px" }} className="relative">
            <img
              src={image.imageUrl}
              alt={`图片 ${index + 1}`}
              style={{
                width: "100px",
                height: "100px",
                objectFit: "cover",
                borderRadius: "8px",
              }}
            />
            {image.uploadStatus === "success" && (
              <p className="absolute top-0 left-0 text-green-400 font-bold bg-black/50 flex w-full h-full items-center justify-center rounded-lg">
                上传成功
              </p>
            )}
            {image.uploadStatus === "fail" && (
              <p className="absolute top-0 left-0 text-red-400 font-bold bg-black/50 flex w-full h-full items-center justify-center rounded-lg">
                上传失败
              </p>
            )}
          </div>
        ))}
        {uploadOne && selectedImages.length ? null : (
          <label
            htmlFor="fileInput"
            style={{
              width: "100px",
              height: "100px",
              margin: "5px",
              background: "#9ca3af",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              position: "relative",
              borderRadius: "8px",
            }}
          >
            <span className="text-white">
              {uploading ? "正在上传..." : "添加图片"}
            </span>
            <input
              id="fileInput"
              type="file"
              multiple
              onChange={handleFileChange}
              style={{
                opacity: 0,
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                cursor: "pointer",
              }}
            />
          </label>
        )}
      </div>
    </div>
  );
};

export default ImageUploader;
